export type TBackBtnTexts = Array<{ title: string; regexp: string }>;

export interface IGetButtonTextByReferrerParams {
  referrer: string;
  backBtnTexts: TBackBtnTexts;
}

export const getButtonTextByReferrer = ({ referrer, backBtnTexts }: IGetButtonTextByReferrerParams): string => {
  for (const el of backBtnTexts) {
    const regexp = new RegExp(el.regexp);
    const isMatch = regexp.test(referrer);

    if (isMatch) {
      return el.title;
    }
  }

  return 'Вернуться назад';
};
